// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"57b9a744","118":"d1cb9a9e","212":"ea07c38e","933":"4f034e44"}[chunkId] + ".css";
};